var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIce3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 104,
    viewBox: "0 0 127 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2497_15259)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2497_15259)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.318 85.6995L102.864 64.8954L88.1672 60.4417L74.9117 57.158L69.8919 16.6595L56.9912 3.39648L35.8399 24.5403L23.6488 51.7834L17.9118 85.6995L3.40332 97.3017H16.3342H31.507H47.5328H55.5343H73.7115H87.2689H106.669H123.661L109.318 85.6995Z",
    fill: "#00E7F9",
    stroke: "#00E7F9",
    strokeWidth: 6.79379,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.661 97.3017H3.40332L17.9118 85.6995L23.6488 51.7834L35.8399 24.5403L56.9912 3.39648L69.8919 16.6595L74.9117 57.158L88.1672 60.4417L102.864 64.8954L109.318 85.6995L123.661 97.3017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6352 74.8671L73.7115 97.3017H3.40332L17.9118 85.6995L23.6488 51.7834L35.8399 24.5403L56.9912 3.39648L53.7151 25.1291H45.9777L53.7151 28.9336L56.9912 56.5918L63.5284 68.6319L88.5219 71.3872L69.6352 74.8671Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7149 25.1284L66.7439 30.722L53.7149 28.9329L45.9775 25.1284H53.7149Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9117 85.6992L31.5068 97.3015H16.334L17.9117 85.6992Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.318 85.6992L99.5352 92.727L106.669 97.3015L104.427 92.5006L106.669 91.5041L113.138 97.3015L109.318 85.6992Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5072 97.3011L30.3598 56.0326L42.8076 25.1284H40.6487L26.2987 53.7529L23.6491 51.7827L17.9121 85.6988L31.5072 97.3011Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9117 57.1592L63.5283 68.6331L88.5219 71.3884L74.9117 57.1592Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9911 56.5923L55.5342 73.9919L63.5282 68.6324L56.9911 56.5923Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6357 74.8672L87.2694 97.3018H73.712L69.6357 74.8672Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5351 92.7273L87.6082 90.2061L87.2686 97.3018H106.669L99.5351 92.7273Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6357 74.8676L87.2694 97.3022L88.5225 71.3877L69.6357 74.8676Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.5344 97.3019L52.3187 82.5217L39.5312 73.9917L47.5328 82.5217V97.3019H55.5344Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40332 97.3027L6.17368 126.161L8.21181 128.864L9.75174 155.548L16.5002 160.447L22.9694 172.835L32.3373 181.41L43.8339 209.883L48.499 210.804L58.1915 241.059L64.5701 240.916L86.9443 260.988L92.3189 224.935L93.1644 221.622L92.8171 214.012L88.4691 204.29L108.873 178.806L108.231 165.55L117.086 144.64L123.661 97.3027H3.40332Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3338 97.3027L14.4014 123.851L18.7041 129.724L20.5762 148.203L32.337 181.41L35.5678 143.674L28.6004 128.328L31.5066 97.3027H16.3338Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5068 97.3027H16.334L28.6005 128.328L31.5068 97.3027Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5333 97.3027L48.6354 112.815L35.5687 143.674L32.3379 181.41L50.6736 128.328L59.5357 115.08L55.5349 97.3027H47.5333Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.5348 97.3027H47.5332L48.6353 112.815L55.5348 97.3027Z",
    fill: "#9BD6EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2686 97.3027L99.5351 114.189V136.073L108.231 165.55L117.086 144.64V109.282L106.669 97.3027H87.2686Z",
    fill: "#E6F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2686 97.3027L117.086 109.282L106.669 97.3027H87.2686Z",
    fill: "#BBE4F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0786 103.288L69.6353 119.759L59.5352 148.64L88.4691 204.289L83.2681 144.383L77.4481 121.775L79.0786 103.288Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2497_15259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 103.352,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2497_15259"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 127.093,
    height: 261.007,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce3);
export default __webpack_public_path__ + "static/media/ice-3.svg";
export { ForwardRef as ReactComponent };